function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import booleanContains from "@turf/boolean-contains";
import { sum, timescale } from "../../utils";
export function findColumnForLocation(columns, position) {
  var lat = position.lat,
      lng = position.lng;
  var point = {
    type: "Point",
    coordinates: [lng, lat]
  };

  var _iterator = _createForOfIteratorHelper(columns),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var column = _step.value;

      if (column.geometry.type == "MultiPolygon") {
        // For some reason, booleanContains doesn't work with MultiPolygon
        // This should be fixed in turf.js v7
        var _iterator2 = _createForOfIteratorHelper(column.geometry.coordinates),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var poly = _step2.value;

            if (booleanContains({
              type: "Polygon",
              coordinates: poly
            }, point)) {
              return column;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        if (booleanContains(column.geometry, point)) {
          return column;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
export function assembleColumnSummary(column, units0) {
  var _column$col_area;

  /** This function has been pulled out of the web v3 codebase and appears
   * to be a mostly unused attempt to find overlapping units. This is somewhat
   * valuable so we'll hope to eventually adapt it into @macrostrat/column-components.
   */
  var columnTimescale = timescale.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      intersectingUnits: 0,
      intersectingUnitIds: []
    });
  });
  var units = units0.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      intersectingUnits: 0,
      intersectingUnitIds: []
    });
  });

  for (var i = 0; i < units.length; i++) {
    units[i].intersectingUnits = 0;
    units[i].intersectingUnitIds = [];

    for (var j = 0; j < units.length; j++) {
      if ( // unit *contains* unit
      (units[i].t_age < units[j].b_age && units[j].t_age < units[i].b_age || // units share t and b age
      units[i].t_age === units[j].t_age && units[i].b_age === units[j].b_age || // units share t_age, but not b_age
      units[i].t_age === units[j].t_age && units[i].b_age <= units[j].b_age || // units share b_age, but not t_age
      units[i].b_age === units[j].b_age && units[i].t_age >= units[j].t_age) && units[i].unit_id != units[j].unit_id) {
        units[i].intersectingUnits += 1;
        units[i].intersectingUnitIds.push(units[j].unit_id);
      }
    }

    for (var _j = 0; _j < columnTimescale.length; _j++) {
      // Need to explicitly overlap, not
      if ( // interval *contains* unit
      units[i].t_age < columnTimescale[_j].b_age && columnTimescale[_j].t_age < units[i].b_age || // interval and unit share t and b age
      units[i].t_age === columnTimescale[_j].t_age && units[i].b_age === columnTimescale[_j].b_age || // interval and unit share t_age, but not b_age
      units[i].t_age === columnTimescale[_j].t_age && units[i].b_age <= columnTimescale[_j].b_age || // interval and unit share b_age, but not t_age
      units[i].b_age === columnTimescale[_j].b_age && units[i].t_age >= columnTimescale[_j].t_age) {
        columnTimescale[_j].intersectingUnitIds.push(units[i].unit_id);
      }
    }
  }

  var unitIdx = {};
  units.forEach(function (unit) {
    unitIdx[unit["unit_id"]] = unit;
    unitIdx[unit["unit_id"]]["drawn"] = false;
  });
  columnTimescale = columnTimescale.filter(function (d) {
    if (d.intersectingUnits > 0) {
      return d;
    }
  });
  return _objectSpread(_objectSpread({}, column), {}, {
    max_thick: sum(units, "max_thick"),
    min_thick: sum(units, "min_thick"),
    pbdb_collections: sum(units, "pbdb_collections"),
    pbdb_occs: sum(units, "pbdb_occurrences"),
    b_age: Math.max.apply(Math, _toConsumableArray(units.map(function (d) {
      return d.b_age;
    }))),
    t_age: Math.min.apply(Math, _toConsumableArray(units.map(function (d) {
      return d.t_age;
    }))),
    area: Number((_column$col_area = column.col_area) !== null && _column$col_area !== void 0 ? _column$col_area : 0),
    timescale: columnTimescale,
    units: units,
    unitIdx: unitIdx
  });
}